<div class="flex-1 4 mb-2 expansion-panel-shadow rounded-xl bg-white">
    @if (isLoading()) {
        <app-loading
            class="m-auto p-1"
            size="30" />
    } @else {
        <app-expansion-panel [isExpanded]="isExpanded()">
            <p
                class="font-normal text-xl !m-0 pl-2"
                header>
                {{ controlsGroup().title }}
            </p>

            <div
                class="flex-1 min-h-0 p-3"
                content>
                @if (isResultRequired()) {
                    @if (fieldInterventionControlResults().length) {
                        <app-field-intervention-form-entity-control-results-header />
                    }

                    @for (controlResult of fieldInterventionControlResults(); track controlResult.id) {
                        <app-field-intervention-form-entity-control-results
                            [controlResult]="controlResult"
                            [initiallyExpanded]="$first"
                            (controlResultUpdated)="controlResultUpdated.emit($event)" />
                    }
                } @else {
                    <app-controls-list [controls]="controlsGroup().controls" />
                }
            </div>
        </app-expansion-panel>
    }
</div>
